export default __webpack_public_path__ + "static/23-316dc7b9975e88a955541e07c9c933c2.webp";